import { CIPageHeader, CIStatusCapsule } from 'ccs-ui-components';
import { useTranslation } from 'react-i18next';

import { useLocation } from 'react-router-dom';
import Header from '../../../../_components/header/Header';
import { IEvent } from '../../../../models/events/IEvent';

import { useSelector } from '../../../../store/AppStore';
import { getClassNameForStatus } from '../../../../utilities/services/ServiceListUtils';
import classes from '../index.module.scss';

interface ICreateTitleBody {
  title: string;
  isSticky: boolean;
  preview: boolean;
  isEditFormClicked: boolean;
  isCreateClicked: boolean;
  eventDetails: Partial<IEvent>[];
  handleCreateEvent: () => void;
  saveAsDraftEnable: () => boolean;
  onCancelCreateEventClicked: () => void;
  handleUpdateEvent: () => void;
}

const CreateTitleBody = ({
  title,
  isSticky,
  preview,
  isEditFormClicked,
  isCreateClicked,
  eventDetails,
  handleCreateEvent,
  saveAsDraftEnable,
  onCancelCreateEventClicked,
  handleUpdateEvent
}: ICreateTitleBody) => {
  const { t: translate } = useTranslation();
  const { success } = useSelector((state) => state.eventReducer);
  const { isLoading } = useSelector((state) => state.getEventIdReducer);
  const location = useLocation();
  const cloneEventName = location.state?.cloneEventName ?? '';

  const getTitle = () => {
    if (cloneEventName?.length) {
      return translate('common_breadcrumn.txt_create_event');
    }
    if (!isCreateClicked && (preview || isEditFormClicked)) {
      return eventDetails[0].eventName;
    }
    return translate(title);
  };

  return (
    <div className={classes.title}>
      <div className={classes['title-wrapper']}>
        <div className={classes['title-name']} id="create">
          <CIPageHeader
            header={
              !isLoading
                ? `${getTitle()}`
                : ''
            }
            className={isSticky ? classes['sticky-header-header'] : ''}
          />
          {!cloneEventName.length && (
          <p className={`${classes['version-text']} ${!isLoading ? classes['text-style'] : ''}`}>
            {(!isLoading && !isCreateClicked && (preview || isEditFormClicked)) ? `Ver ${eventDetails[0]?.version}` : ''}
            {(!isLoading && isCreateClicked && (preview || (isEditFormClicked && success))) ? `Ver ${eventDetails[0].version}` : ''}
          </p>
          )}

        </div>
        {eventDetails[0].status && !cloneEventName.length && (
          <CIStatusCapsule
            status={eventDetails[0].status}
            className={getClassNameForStatus(
              eventDetails[0].status ?? '',
              classes.statusheader,
              classes
            )}
          />
        )}
      </div>
      <div className={classes['btn-edit-space']}>
        {!preview && (
          <Header
            onAddClicked={handleCreateEvent}
            disabled={saveAsDraftEnable()}
            isEditClicked={isEditFormClicked}
            onCancelClicked={onCancelCreateEventClicked}
            onUpdateClicked={handleUpdateEvent}
          />
        )}
      </div>
    </div>
  );
};

export default CreateTitleBody;
